import { HARD_MAX_BYTES, formatMb } from './mediaSizeLimits';
import { getMissingSystemTypeError } from './validateSystemTypeSelection';

interface ValidateInspectionSubmitInput {
  totalMediaBytes: number;
  hvacSystems: Array<{ systemType?: unknown }>;
  plumbingSystems: Array<{ systemType?: unknown }>;
}

/**
 * First reason the report cannot be submitted, or null. Order matters: media over the
 * backend's 200 MB limit first, then the first HVAC system without a type, then plumbing.
 */
export function validateInspectionSubmit({
  totalMediaBytes,
  hvacSystems,
  plumbingSystems,
}: ValidateInspectionSubmitInput): string | null {
  if (totalMediaBytes > HARD_MAX_BYTES) {
    return `Your photos and videos total ${formatMb(totalMediaBytes)}, over the 200 MB limit. Please remove or shorten some media and try again.`;
  }
  return getMissingSystemTypeError(hvacSystems, 'HVAC') ?? getMissingSystemTypeError(plumbingSystems, 'Plumbing');
}
